import { Immutable } from "immer";
import React from "react";
import { prefillSSRReviewsPageData } from "tsi-common-react/src/apps/reviews/ssr";
import { isoReviewsBrandID } from "tsi-common-react/src/models/nominals";
import { useSSRStorePrefill } from "tsi-common-react/src/store/reducers";

import { templates } from "@reactivated";

import { ReviewsViewer } from "../ReviewsViewer";

type IProps = Immutable<templates.ReviewsPageTemplate>;

export const ReviewsViewerSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            products_data: props.products_data,
            reviews_data: props.reviews_data,
            facets_data: props.facets_data,
            brand_id: props.brand_id,
            default_sort: props.default_sort,
            product_type_whitelist_ids: props.product_type_whitelist_ids,
        },
        prefillSSRReviewsPageData,
    );

    const brandID = isoReviewsBrandID.wrap(props.brand_id);

    return <ReviewsViewer brandID={brandID} />;
};
